<template lang="pug">
div
  v-simple-table(style="background: #ffffffe0")
    template(v-slot:default)
      thead
        tr
          th.text-left Name
          th.text-left Type
      tbody
        tr(v-for="(item, i) in items", :key="i")
          td
            template(v-if="item.inaccessible")
              span(v-text="item.label")
              v-icon.ml-4(v-if="item.warning", color="error") mdi-alert-decagram
              v-btn.ml-2(v-if="item.url", icon, @click="download(item)")
                v-icon mdi-download
            template(v-else)
              span(v-text="item.document_template.name")
              template(v-if="item.files.length > 0")
                v-btn.ml-2(icon, @click="docs = item.files; docsShown = true")
                  v-icon mdi-eye
          td(v-text="item.status")
  DocViewer(v-model="docsShown", :docs="docs")
</template>

<script>
import DocViewer from "@/components/Documents/Viewer";

export default {
  name: "document_table",

  components: {
    DocViewer,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    docs: [],
    docsShown: false,
  }),

  methods: {
    download({ url, filename }) {
      this.axios
        .get(url, { responseType: "blob" })
        .then((resp) => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([resp.data]));
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>